import React from 'react';
import ShopApplicationForm from '../ShopApplicationForm';

const ShopApplicationFormRequestNew = () => {
  return <ShopApplicationForm mode="create" />;
};

export default ShopApplicationFormRequestNew;
